import { FC, useContext, useEffect, useState } from "react";
import { Badge, Tooltip } from "@mui/material";
import AppStateContext from "../../contexts/AppStateContext";
import type { NavBadgeProps } from "dashboard_layout/navigation";
import { apiGetLabelIssues } from "../../util/network/Shipping";

/** Shows how many label issues are open. Like ReviewQuoteBadge it does not
 *  track visits, so `active` is unused. */
const LabelIssuesBadge: FC<NavBadgeProps> = () => {
  const { token } = useContext(AppStateContext);
  const [openIssues, setOpenIssues] = useState<number>(0);

  const fetchIssues = (): Promise<void> => {
    if (token) {
      return apiGetLabelIssues(token, "open")
        .then((issues) => setOpenIssues(issues.length))
        .catch((err) => {
          console.error("Error retrieving label issues", err);
        });
    }
    return Promise.resolve();
  };

  useEffect(() => {
    fetchIssues();
    const intervalId = setInterval(fetchIssues, 600000);
    return () => clearInterval(intervalId);
  }, [token]);

  return (
    <>
      {openIssues > 0 && (
        <Tooltip title="Open label issues">
          <Badge color={"warning"} badgeContent={openIssues} />
        </Tooltip>
      )}
    </>
  );
};
export default LabelIssuesBadge;
